import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { MapService } from '../services/map.service';
import { GeoJson, FeatureCollection } from '../models/map';


@Component({
  selector: 'map-box',
  providers: [MapService],
  templateUrl: './map-box.component.html',
  styleUrls: ['./map-box.component.css']
})
export class MapBoxComponent implements OnInit {
  // default settings
  map: mapboxgl.Map;
  style = 'mapbox://styles/mapbox/satellite-v9';
  lat = 47.076560465252754;
  lng = -122.69403540006951;
  message = 'Hello World!';
  geojson = new GeoJson([this.lng, this.lat]);
  @Output() notify: EventEmitter<string> = new EventEmitter<string>();  
  @Input() project;
  constructor(private mapService: MapService) {
  }

  ngOnInit() {
    this.initializeMap()
  }

  private initializeMap() {
    // locate the user
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(position => {
    //     this.lat = position.coords.latitude;
    //     this.lng = position.coords.longitude;
    //     this.map.flyTo({
    //       center: [this.lng, this.lat]
    //     })
    //   });
    // }
    this.buildMap()
  }

  buildMap() {
    // authorize mapboxgl
    mapboxgl.accessToken = this.project.mapbox_token;
    
    // initialize map
    this.map = new mapboxgl.Map({
      container: 'map',
      style: this.project.mapbox_style,
      zoom: this.project.map_zoom,
      center: [this.project.map_center_lng, this.project.map_center_lat]
    });

    // set extent if populated
    if(this.project.map_extent_sw_lat != null && this.project.map_extent_sw_lng != null
    && this.project.map_extent_ne_lat != null && this.project.map_extent_ne_lng) {
      var sw = new mapboxgl.LngLat(this.project.map_extent_sw_lng, this.project.map_extent_sw_lat);
      var ne = new mapboxgl.LngLat(this.project.map_extent_ne_lng, this.project.map_extent_ne_lat);
      this.map.setMaxBounds(new mapboxgl.LngLatBounds(sw, ne));
    }
    // add map controls
    this.map.addControl(new mapboxgl.NavigationControl());

    // add a point on map click
    this.map.on('click', (event) => {
      const coordinates = [event.lngLat.lng, event.lngLat.lat];
      const newMarker = new GeoJson(coordinates);
      this.notify.emit('POINT(' + event.lngLat.lng + ' ' + event.lngLat.lat + ')');
      console.log("marker: ", newMarker);
      try {
        this.map.removeSource("point");
        this.map.removeLayer("point");
      }
      catch(err) {}
   
      // Add a single point to the map
      this.map.addSource('point', {
        "type": "geojson",
        "data": newMarker
      });

      this.map.addLayer({
        "id": "point",
        "type": "circle",
        "source": "point",
        "paint": {
          "circle-radius": 10,
          "circle-color": this.project.map_point_hex
        }
      });
    })
  }

  // clear map
  clear(){
    try {
      this.map.setCenter([this.lng, this.lat]);
      this.map.setZoom(15);
      this.map.removeSource("point");
      this.map.removeLayer("point");
    }
    catch(err) {}
  }
}



// WEBPACK FOOTER //
// ./src/app/map-box/map-box.component.ts